function createServicesRules(services) {
    return services ? services.split(',').map((service) => {
        const key = service.trim()
        return {
            key,
            rules: {
                type: 'dynamic-script',
                search: key,
                language: {
                    locale: {
                        en: {
                            name: key
                        },
                    }
                }
            }
        };
    }) : []
}

window.initCookie = function(settings) {
    if (settings && settings.popup_enabled) {
        const analyticServices = createServicesRules(settings.other_analytics_services)
        const marketingServices = createServicesRules(settings.other_marketing_services)

        if (settings.google_analytics) {
            analyticServices.push({
                key: 'googleAnalytics',
                rules: {
                    type: 'dynamic-script',
                    search: 'google-analytics',
					cookies: [
						{
							name: '_gid',
						},
						{
							name: /^_ga/,
						},
					],
                    language: {
                        locale: {
                            en: {
                                name: 'Google Analytics'
                            },
                        }
                    }
                }
            })
        }

        if (settings.facebook_ads) {
            marketingServices.push({
                key: 'facebookPixel',
                rules: {
                    type: 'dynamic-script',
                    search: 'facebook',
                    language: {
                        locale: {
                            en: {
                                name: 'Facebook Pixel'
                            },
                        }
                    }
                }
            })
        }

        if (settings.google_ads) {
            marketingServices.push({
                key: 'googleadservices',
                rules: {
                    type: 'dynamic-script',
                    search: 'googleadservices',
                    language: {
                        locale: {
                            en: {
                                name: 'Google Adwords'
                            },
                        }
                    }
                }
            })
        }

        const localCookies = [
            {
                key: 'XSRFTOKEN',
                rules: {
                    type: 'localcookie',
                    cookies: [
                        {
                            name: 'XSRF-TOKEN',
                            domain: `${window.location.hostname}`
                        },
                    ],
                    language: {
                        locale: {
                            en: {
                                name: 'XSRF-TOKEN'
                            },
                        }
                    }
                }
            },
            {
                key: 'scoreappSession',
                rules: {
                    type: 'localcookie',
                    cookies: [
                        {
                            name: 'scoreapp_session',
                            domain: `${window.location.hostname}`
                        },
                    ],
                    language: {
                        locale: {
                            en: {
                                name: 'scoreapp_session'
                            },
                        }
                    }
                }
            },
            {
                key: 'score',
                rules: {
                    type: 'localcookie',
                    cookies: [
                        {
                            name: '_score',
                            domain: `${window.location.hostname}`
                        },
                    ],
                    language: {
                        locale: {
                            en: {
                                name: '_score'
                            },
                        }
                    }
                }
            }
        ];

        const { categories, services } = [
            {
                key: 'necessary',
                services: localCookies,
                rules: {
                    needed: true,
                    wanted: true,
                    checked: true,
                    language: {
                        locale: {
                            en: {
                                name: 'Strictly Necessary Cookies',
                                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eu commodo est, nec gravida odio. Suspendisse scelerisque a ex nec semper.',
                            }
                        }
                    }
                },
            },
            {
                key: 'analytic',
                services: analyticServices,
                rules: {
                    needed: false,
                    wanted: !settings.explicit_consent,
                    checked: false,
                    language: {
                        locale: {
                            en: {
                                name: 'Analytic Cookies',
                                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eu commodo est, nec gravida odio. Suspendisse scelerisque a ex nec semper.',
                            }
                        }
                    }
                },
            },
            {
                key: 'marketing',
                services: marketingServices,
                rules: {
                    needed: false,
                    wanted: !settings.explicit_consent,
                    checked: false,
                    language: {
                        locale: {
                            en: {
                                name: 'Marketing Cookies',
                                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eu commodo est, nec gravida odio. Suspendisse scelerisque a ex nec semper.',
                            }
                        }
                    }
                },
            },
        ].reduce((acc, category) => {
            if (category.services.length) {
                acc.categories[category.key] = category.rules;
                acc.services = category.services.reduce(
                    (accServices, service) => {
                        accServices[service.key] = { category: category.key, ...service.rules};
                        return accServices;
                    },
                    acc.services
                )
            }
            return acc
        }, { categories: {}, services: {} })

        window.CookieConsent.init({
            theme: {
                barColor: '#2C7CBF',
                barTextColor: '#FFF',
                barMainButtonColor: '#FFF',
                barMainButtonTextColor: '#2C7CBF',
                modalMainButtonColor: '#4285F4',
                modalMainButtonTextColor: '#FFF',
            },
            language: {
                current: 'en',
                locale: {
                    en: {
                        barMainText: 'This website uses cookies to ensure you get the best experience on our website.',
                        barLinkSetting: 'Cookie Settings',
                        barBtnAcceptAll: 'Accept all cookies',
                        modalMainTitle: 'Cookie settings',
                        modalMainText: 'Cookies are small piece of data sent from a website and stored on the user\'s computer by the user\'s web browser while the user is browsing. Your browser stores each message in a small file, called cookie. When you request another page from the server, your browser sends the cookie back to the server. Cookies were designed to be a reliable mechanism for websites to remember information or to record the user\'s browsing activity.',
                        modalBtnSave: 'Save current settings',
                        modalBtnAcceptAll: 'Accept all cookies and close',
                        modalAffectedSolutions: 'Affected solutions:',
                        learnMore: 'Learn More',
                        on: 'On',
                        off: 'Off',
                    }
                }
            },
            categories,
            services,
        });
    }
}
